// Planner task status colours (Trent, Nov 2026):
// blue = future, yellow = in progress (by dates or any % logged),
// green = completed, red = overdue (past finish, not done).
export const TASK_STATUS_COLORS = {
  done:     { base: "#8ce0b4", fill: "#059669", label: "Completed" },
  progress: { base: "#fcd34d", fill: "#d97706", label: "In progress" },
  future:   { base: "#7fb3dd", fill: "#2f6ea5", label: "Future" },
  late:     { base: "#fda4af", fill: "#e11d48", label: "Overdue" },
};

export function taskStatus(t) {
  const today = new Date().toLocaleDateString("en-CA");
  const pct = Number(t.percent) || 0;
  if (pct >= 100) return "done";
  const finish = (t.finish || "").slice(0, 10);
  if (finish && finish < today) return "late";
  const start = (t.start || "").slice(0, 10);
  if ((start && start <= today) || pct > 0) return "progress";
  return "future";
}
